class TopCollectionsSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.top-collections__track');
    this.prevBtn = el.querySelector('.top-collections__arrow--prev');
    this.nextBtn = el.querySelector('.top-collections__arrow--next');

    if (!this.track) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.scrollByCards(-1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.scrollByCards(1));
    this.track.addEventListener('scroll', () => this.updateArrowState());
    window.addEventListener('resize', () => this.updateArrowState());

    this.updateArrowState();
  }

  scrollByCards(direction) {
    const card = this.track.querySelector('.top-collections__card');
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width + 20; // gap
    this.track.scrollBy({ left: cardWidth * 2 * direction, behavior: 'smooth' });
  }

  updateArrowState() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 4;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 4;
  }
}

document.querySelectorAll('.top-collections').forEach((el) => new TopCollectionsSlider(el));

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target.querySelector('.top-collections');
    if (el) new TopCollectionsSlider(el);
  });
}